import { render, staticRenderFns } from "./VSnow.vue?vue&type=template&id=5d52edc0&"
import script from "./VSnow.vue?vue&type=script&lang=ts&"
export * from "./VSnow.vue?vue&type=script&lang=ts&"
import style0 from "./VSnow.vue?vue&type=style&index=0&id=5d52edc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports